import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartSquareBar = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14.6666 7.33341V14.6667M11 10.0834V14.6667M7.33329 12.8334V14.6667M5.49996 18.3334H16.5C16.9862 18.3334 17.4525 18.1403 17.7963 17.7964C18.1401 17.4526 18.3333 16.9863 18.3333 16.5001V5.50008C18.3333 5.01385 18.1401 4.54754 17.7963 4.20372C17.4525 3.8599 16.9862 3.66675 16.5 3.66675H5.49996C5.01373 3.66675 4.54741 3.8599 4.2036 4.20372C3.85978 4.54754 3.66663 5.01385 3.66663 5.50008V16.5001C3.66663 16.9863 3.85978 17.4526 4.2036 17.7964C4.54741 18.1403 5.01373 18.3334 5.49996 18.3334Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgChartSquareBar;
